export default __webpack_public_path__ + "scripts/resources/assignments/en/colligative/vapor_pressure/reactions.json";